import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { TokenExchangeDTO } from '../../services/apiClient';

interface Props {
  setErrorMessage: (message: string | null) => void;
  handleGoogleSignIn: (dto: TokenExchangeDTO) => void;
}

const GoogleLoginButton: React.FC<Props> = ({
  setErrorMessage,
  handleGoogleSignIn,
}) => {

  const handleSuccess = async (response: any) => {
    handleGoogleSignIn({
        token: response.credential,
    })
};

  return (
    <GoogleLogin onSuccess={handleSuccess} onError={() => setErrorMessage("Google Authentication failed.")}/>
  );
};

export default GoogleLoginButton;
